export default {
  name: 'Mobile',

  computed: {
    isMobile() {
      return this.isIOS || this.isAndroid;
    },

    isIOS() {
      const userAgent = window.navigator.userAgent;

      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return true;
      }
      return false;
    },

    isAndroid() {
      const userAgent = window.navigator.userAgent;

      if (userAgent.match(/android/i)) {
        return true;
      }
      return false;
    },

    getAndroidVersion() {
      const userAgent = window.navigator.userAgent;
      const regex = /android\s([0-9]*)/;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return match[1];
      }

      return 0;
    },

    isOldAndroid() {
      if (this.isAndroid && this.versionCompare(this.getAndroidVersion, '5.0.0') < 0) {
        return true;
      }

      return false;
    },

    isClasstingAndroidVersion() {
      const userAgent = window.navigator.userAgent;
      const regex = /classting_android,\s([0-9])*/;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    },

    isClasstingIosVersion() {
      const userAgent = window.navigator.userAgent;
      const regex = /classting_iphone/;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    },

  },

  methods: {
    /* eslint-disable */
    call(url) {
      if (this.isIOS) {
        window.location = url;
      } else {
        if (!window.ctandroid) {
          // android under 4.2
          window.prompt(url);
        } else {
          window.ctandroid.submitFromWeb(url);
        }
      }
    },
    /* eslint-enable */

    versionCompare(left, right) {
      if (!(typeof left === 'string' && typeof right === 'string')) {
        return false;
      }

      const a = left.split('.');
      const b = right.split('.');
      const len = Math.max(a.length, b.length);

      for (let i = 0; i < len; i += 1) {
        if ((a[i] && !b[i] && parseInt(a[i], 10) > 0) ||
          (parseInt(a[i], 10) > parseInt(b[i], 10))) {
          return 1;
        } else if ((b[i] && !a[i] && parseInt(b[i], 10) > 0) ||
          (parseInt(a[i], 10) < parseInt(b[i], 10))) {
          return -1;
        }
      }

      return 0;
    },

    callActionbar(isVisible) {
      this.call(`ctjscall://navigation?source=classting&is_visible=${isVisible}`);
    },

  },
};



// WEBPACK FOOTER //
// ./src/mixins/Mobile.js